// // import { useMemo } from "react";
// // import { Box, Typography } from "@mui/material";
// // import { DataGrid } from "@mui/x-data-grid";
// // import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";
// // import { getOrderLinesColumns } from "./orderUtils";

// // const OrderLinesTable = ({ orderLines }) => {
// //   console.log("Order lines props test", orderLines)
// //   const hasCanceledLines = useMemo(() => {
// //     return orderLines?.some((line) => line.line_state === "canceled");
// //   }, [orderLines]);

// //   const orderLinesColumns = useMemo(
// //     () => getOrderLinesColumns(hasCanceledLines),
// //     [hasCanceledLines]
// //   );

// //   return (
// //     <Box>
// //       <Typography
// //         variant="subtitle1"
// //         sx={{
// //           fontWeight: 600,
// //           mb: 2,
// //           color: "#202124",
// //           fontSize: "16px",
// //         }}
// //       >
// //         Order Lines
// //       </Typography>
// //       <DataGrid
// //         rows={orderLines || []}
// //         columns={orderLinesColumns}
// //         autoHeight
// //         disableRowSelectionOnClick
// //         getRowId={(row) => row.line_id}
// //         hideFooter
// //         slots={{
// //           loadingOverlay: CustomLoadingOverlay,
// //         }}
// //         disableColumnMenu
// //         sx={{
// //           border: "1px solid #E6E8F0",
// //           borderRadius: "8px",
// //           overflow: "hidden",
// //           "& .MuiDataGrid-cell": {
// //             fontSize: "13px",
// //             fontWeight: 500,
// //             color: "#374151",
// //             borderColor: "#F0F0F0",
// //           },
// //           "& .MuiDataGrid-columnHeader": {
// //             backgroundColor: "#d6d6d6ff !important",
// //             color: "#fff !important",
// //           },
// //           "& .MuiDataGrid-columnHeaderTitle": {
// //             fontWeight: 700,
// //             color: "#242424ff !important",
// //           },
// //           "& .MuiDataGrid-columnSeparator": {
// //             color: "rgba(177, 177, 177, 1)",
// //           },
// //           "& .MuiDataGrid-row": {
// //             cursor: "pointer",
// //           },
// //         }}
// //       />
// //     </Box>
// //   );
// // };

// // export default OrderLinesTable;


// // ************************************************************************************************************************************
// import { useMemo } from "react";
// import { Box, Typography, Divider } from "@mui/material";
// import InfoIcon from "@mui/icons-material/Info";
// import { DataGrid } from "@mui/x-data-grid";
// import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";
// import { getOrderLinesColumns } from "./orderUtils";

// const OrderLinesTable = ({ orderLines }) => {
//   console.log("Order lines props test", orderLines);
  
//   const hasCanceledLines = useMemo(() => {
//     return orderLines?.some((line) => line.line_state === "canceled");
//   }, [orderLines]);

//   const orderLinesColumns = useMemo(
//     () => getOrderLinesColumns(hasCanceledLines),
//     [hasCanceledLines]
//   );

//   // Function to get row background color
//   const getRowBackgroundColor = (row) => {
//     // Canceled lines always get red
//     if (row.line_state === "canceled") {
//       return "#ffebee";
//     }
    
//     // If color is provided by API
//     if (row?.order_line_color_satate) {
//       // Handle "white" string specifically to ensure proper white color
//       if (row.order_line_color_satate === "white") {
//         return "#ffffff";
//       }
//       // Return any other color value
//       return row.order_line_color_satate;
//     }
    
//     // Default to white if nothing provided
//     return "#ffffff";
//   };

//   return (
//     <Box>
//       <Typography
//         variant="subtitle1"
//         sx={{
//           fontWeight: 600,
//           mb: 2,
//           color: "#202124",
//           fontSize: "16px",
//         }}
//       >
//         Order Lines
//       </Typography>

//       {/* Color Legend */}
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "flex-start",
//           mb: 2,
//           flexWrap: "wrap",
//           gap: 1,
//         }}
//       >
//         <InfoIcon sx={{ fontSize: "0.875rem", marginRight: "4px", color: "#667085" }} />
//         <Typography
//           variant="body2"
//           sx={{
//             fontSize: "0.75rem",
//             textAlign: "left",
//             marginRight: "8px",
//             color: "green",
//           }}
//         >
//           Green - Picked
//         </Typography>
//         <Divider orientation="vertical" flexItem sx={{ marginRight: "8px" }} />
//         <Typography
//           variant="body2"
//           sx={{
//             fontSize: "0.75rem",
//             textAlign: "left",
//             marginRight: "8px",
//             color: "#FF0000",
//           }}
//         >
//           Red - Canceled
//         </Typography>
//         <Divider orientation="vertical" flexItem sx={{ marginRight: "8px" }} />
//         <Typography
//           variant="body2"
//           sx={{
//             fontSize: "0.75rem",
//             textAlign: "left",
//             marginRight: "8px",
//             color: "#be8800",
//           }}
//         >
//           Yellow - Freight
//         </Typography>
//         <Divider orientation="vertical" flexItem sx={{ marginRight: "8px" }} />
//         <Typography
//           variant="body2"
//           sx={{
//             fontSize: "0.75rem",
//             textAlign: "left",
//           }}
//         >
//           White - Not Picked
//         </Typography>
//       </Box>

//       <DataGrid
//         rows={orderLines || []}
//         columns={orderLinesColumns}
//         autoHeight
//         disableRowSelectionOnClick
//         getRowId={(row) => row.line_id}
//         hideFooter
//         slots={{
//           loadingOverlay: CustomLoadingOverlay,
//         }}
//         disableColumnMenu
//         getRowClassName={(params) => {
//           const backgroundColor = getRowBackgroundColor(params.row);
//           return `row-${params.row.line_id}`;
//         }}
//         sx={{
//           border: "1px solid #E6E8F0",
//           borderRadius: "8px",
//           overflow: "hidden",
//           "& .MuiDataGrid-cell": {
//             fontSize: "13px",
//             fontWeight: 500,
//             color: "#374151",
//             borderColor: "#F0F0F0",
//           },
//           "& .MuiDataGrid-columnHeader": {
//             backgroundColor: "#d6d6d6ff !important",
//             color: "#fff !important",
//           },
//           "& .MuiDataGrid-columnHeaderTitle": {
//             fontWeight: 700,
//             color: "#242424ff !important",
//           },
//           "& .MuiDataGrid-columnSeparator": {
//             color: "rgba(177, 177, 177, 1)",
//           },
//           "& .MuiDataGrid-row": {
//             cursor: "pointer",
//           },
//         }}
//         componentsProps={{
//           row: {
//             style: (params) => {
//               const backgroundColor = getRowBackgroundColor(params.row);
//               return {
//                 backgroundColor: backgroundColor,
//                 "&:hover": {
//                   backgroundColor: backgroundColor,
//                 },
//               };
//             },
//           },
//         }}
//       />
      
//       {/* Add style tag for dynamic row colors */}
//       <style>
//         {orderLines?.map((row) => {
//           const backgroundColor = getRowBackgroundColor(row);
//           return `
//             .MuiDataGrid-row.row-${row.line_id} {
//               background-color: ${backgroundColor} !important;
//             }
//             .MuiDataGrid-row.row-${row.line_id}:hover {
//               background-color: ${backgroundColor} !important;
//             }
//             .MuiDataGrid-row.row-${row.line_id}.Mui-selected {
//               background-color: ${backgroundColor} !important;
//             }
//           `;
//         }).join("")}
//       </style>
//     </Box>
//   );
// };

// export default OrderLinesTable;

// *********************************************************************************
// import { useMemo, useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Divider,
//   TableContainer,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   TablePagination,
// } from "@mui/material";
// import InfoIcon from "@mui/icons-material/Info";
// import { getOrderLinesColumns } from "./orderUtils";
// import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";
// import httpclient from "../../../../Utils";
// import { useNotification } from "../../../../Hooks/useNotification";
// import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
// import useTokenRefresh from "../../../../Hooks/useTokenRefresh";

// const OrderLinesTable = ({ jobId }) => {
//   const [orderLinesData, setOrderLinesData] = useState([]); // Already initialized as empty array
//   const [totalRows, setTotalRows] = useState(0);
//   const [currentPage, setCurrentPage] = useState(0); // 0-indexed for MUI TablePagination
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [loading, setLoading] = useState(false);

//   const showNotification = useNotification();
//   const handleApiError = useApiErrorHandler();
//   const { getTokenRefreshed: tokenRefresh } = useTokenRefresh();

//   // Fetch order lines with pagination
//   const fetchOrderLines = async () => {
//     if (!jobId) {
//       setOrderLinesData([]);
//       setTotalRows(0);
//       return;
//     }

//     setLoading(true);
//     const API_URL = `/delivery/orders/details/${jobId}?page=${currentPage + 1}&pagination=${rowsPerPage}`;

//     try {
//       const res = await httpclient.get(API_URL);
//       const { data } = res;
//       console.log("this is the pagiation test ", data)

//       if (data.status === 200) {
//         // Ensure we always set an array for orderLinesData
//         let linesData = [];
//         let totalCount = 0;
        
//         // Check different possible response structures
//         if (data.data?.orderLines?.data) {
//           // Structure: { data: { orderLines: { data: [], total: 0 } } }
//           linesData = Array.isArray(data.data.orderLines.data) ? data.data.orderLines.data : [];
//           totalCount = data.data.orderLines.total || 0;
//         } else if (data.data?.orderLines) {
//           // Structure: { data: { orderLines: [] } }
//           linesData = Array.isArray(data.data.orderLines) ? data.data.orderLines : [];
//           totalCount = linesData.length;
//         } else if (data.data && Array.isArray(data.data)) {
//           // Structure: { data: [] }
//           linesData = data.data;
//           totalCount = data.total || linesData.length;
//         } else if (Array.isArray(data.data)) {
//           // Structure: { data: [] }
//           linesData = data.data;
//           totalCount = data.total || linesData.length;
//         } else if (data.orderLines && Array.isArray(data.orderLines)) {
//           // Structure: { orderLines: [] }
//           linesData = data.orderLines;
//           totalCount = data.total || linesData.length;
//         } else {
//           // Fallback: try to get any array from the response
//           linesData = [];
//           totalCount = 0;
//         }
        
//         setOrderLinesData(linesData);
//         setTotalRows(totalCount);
//       } else {
//         showNotification("error", data.message || "Failed to fetch order lines");
//         setOrderLinesData([]);
//         setTotalRows(0);
//       }
//     } catch (error) {
//       console.error("Error fetching order lines:", error);
//       if (error?.response?.status === 401) {
//         tokenRefresh();
//       } else {
//         handleApiError(error);
//       }
//       setOrderLinesData([]);
//       setTotalRows(0);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchOrderLines();
//   }, [jobId, currentPage, rowsPerPage]);

//   // Safe check: ensure orderLinesData is an array before using array methods
//   const hasCanceledLines = useMemo(() => {
//     return Array.isArray(orderLinesData) && orderLinesData?.some((line) => line.line_state === "canceled");
//   }, [orderLinesData]);

//   const orderLinesColumns = useMemo(
//     () => getOrderLinesColumns(hasCanceledLines),
//     [hasCanceledLines]
//   );

//   // Function to get row background color
//   const getRowBackgroundColor = (row) => {
//     if (!row) return "#ffffff";
    
//     if (row.line_state === "canceled") {
//       return "#ffebee";
//     }
    
//     if (row?.order_line_color_satate) {
//       if (row.order_line_color_satate === "white") {
//         return "#ffffff";
//       }
//       return row.order_line_color_satate;
//     }
    
//     return "#ffffff";
//   };

//   const handleChangePage = (event, newPage) => {
//     setCurrentPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setCurrentPage(0); // Reset to first page when changing rows per page
//   };

//   // Ensure we have an array to map over
//   const safeOrderLinesData = Array.isArray(orderLinesData) ? orderLinesData : [];

//   return (
//     <Box sx={{ mt: 2 }}>
//       <Typography
//         variant="subtitle1"
//         sx={{
//           fontWeight: 600,
//           mb: 2,
//           color: "#202124",
//           fontSize: "16px",
//         }}
//       >
//         Order Lines
//       </Typography>

//       {/* Color Legend */}
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "flex-start",
//           mb: 2,
//           flexWrap: "wrap",
//           gap: 1,
//         }}
//       >
//         <InfoIcon sx={{ fontSize: "0.875rem", marginRight: "4px", color: "#667085" }} />
//         <Typography
//           variant="body2"
//           sx={{
//             fontSize: "0.75rem",
//             textAlign: "left",
//             marginRight: "8px",
//             color: "green",
//           }}
//         >
//           Green - Picked
//         </Typography>
//         <Divider orientation="vertical" flexItem sx={{ marginRight: "8px" }} />
//         <Typography
//           variant="body2"
//           sx={{
//             fontSize: "0.75rem",
//             textAlign: "left",
//             marginRight: "8px",
//             color: "#FF0000",
//           }}
//         >
//           Red - Canceled
//         </Typography>
//         <Divider orientation="vertical" flexItem sx={{ marginRight: "8px" }} />
//         <Typography
//           variant="body2"
//           sx={{
//             fontSize: "0.75rem",
//             textAlign: "left",
//             marginRight: "8px",
//             color: "#be8800",
//           }}
//         >
//           Yellow - Freight
//         </Typography>
//         <Divider orientation="vertical" flexItem sx={{ marginRight: "8px" }} />
//         <Typography
//           variant="body2"
//           sx={{
//             fontSize: "0.75rem",
//             textAlign: "left",
//           }}
//         >
//           White - Not Picked
//         </Typography>
//       </Box>

//       <TableContainer sx={{ mb: 3, position: "relative" }}>
//         <Table sx={{ minWidth: 650 }}>
//           <TableHead>
//             <TableRow sx={{ backgroundColor: "#d6d6d6ff" }}>
//               {orderLinesColumns.map((column) => (
//                 <TableCell 
//                   key={column.id} 
//                   align={column.align || "left"}
//                   sx={{
//                     fontWeight: 700,
//                     color: "#242424ff",
//                   }}
//                 >
//                   {column.header}
//                 </TableCell>
//               ))}
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {loading ? (
//               <TableRow>
//                 <TableCell colSpan={orderLinesColumns.length} align="center">
//                   <CustomLoadingOverlay loadingText="Loading order lines..." />
//                 </TableCell>
//               </TableRow>
//             ) : safeOrderLinesData.length === 0 ? (
//               <TableRow>
//                 <TableCell colSpan={orderLinesColumns.length} align="center">
//                   <Typography variant="body2" color="text.secondary">
//                     No order lines found
//                   </Typography>
//                 </TableCell>
//               </TableRow>
//             ) : (
//               safeOrderLinesData.map((row) => (
//                 <TableRow
//                   key={row.line_id || row.id || Math.random()}
//                   sx={{
//                     backgroundColor: getRowBackgroundColor(row),
//                     "&:hover": {
//                       backgroundColor: getRowBackgroundColor(row),
//                     },
//                     cursor: "pointer",
//                   }}
//                 >
//                   {orderLinesColumns.map((column) => (
//                     <TableCell
//                       key={`${row.line_id || row.id}-${column.id}`}
//                       align={column.align || "left"}
//                       sx={{
//                         fontSize: "13px",
//                         fontWeight: 500,
//                         color: "#374151",
//                         borderColor: "#F0F0F0",
//                       }}
//                     >
//                       {column.render
//                         ? column.render(row)
//                         : row[column.field]}
//                     </TableCell>
//                   ))}
//                 </TableRow>
//               ))
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       {/* Pagination Component - Exactly matching the pattern from OrderLineItemsTable */}
//       <TablePagination
//         component="div"
//         count={totalRows}
//         page={currentPage}
//         onPageChange={handleChangePage}
//         rowsPerPage={rowsPerPage}
//         onRowsPerPageChange={handleChangeRowsPerPage}
//         rowsPerPageOptions={[5, 10, 20, 50]}
//       />
//     </Box>
//   );
// };

// export default OrderLinesTable;


// ********************************************************************************************

import { useMemo, useState, useEffect } from "react";
import {
  Box,
  Typography,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { getOrderLinesColumns } from "./orderUtils";
import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";
import httpclient from "../../../../Utils";
import { useNotification } from "../../../../Hooks/useNotification";
import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
import useTokenRefresh from "../../../../Hooks/useTokenRefresh";

const OrderLinesTable = ({ jobId }) => {
  const [orderLinesData, setOrderLinesData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();
  const { getTokenRefreshed: tokenRefresh } = useTokenRefresh();

  // Fetch order lines with pagination
  const fetchOrderLines = async () => {
    if (!jobId) {
      setOrderLinesData([]);
      setTotalRows(0);
      return;
    }

    setLoading(true);
    const API_URL = `/delivery/orders/details/${jobId}?page=${currentPage + 1}&pagination=${rowsPerPage}`;

    try {
      const res = await httpclient.get(API_URL);
      const { data } = res;
      console.log("this is the pagiation test ", data)

      if (data.status === 200) {
        let linesData = [];
        let totalCount = 0;
        
        if (data.data?.orderLines?.data) {
          linesData = Array.isArray(data.data.orderLines.data) ? data.data.orderLines.data : [];
          totalCount = data.data.orderLines.total || 0;
        } else if (data.data?.orderLines) {
          linesData = Array.isArray(data.data.orderLines) ? data.data.orderLines : [];
          totalCount = linesData.length;
        } else if (data.data && Array.isArray(data.data)) {
          linesData = data.data;
          totalCount = data.total || linesData.length;
        } else if (Array.isArray(data.data)) {
          linesData = data.data;
          totalCount = data.total || linesData.length;
        } else if (data.orderLines && Array.isArray(data.orderLines)) {
          linesData = data.orderLines;
          totalCount = data.total || linesData.length;
        } else {
          linesData = [];
          totalCount = 0;
        }
        
        setOrderLinesData(linesData);
        setTotalRows(totalCount);
      } else {
        showNotification("error", data.message || "Failed to fetch order lines");
        setOrderLinesData([]);
        setTotalRows(0);
      }
    } catch (error) {
      console.error("Error fetching order lines:", error);
      if (error?.response?.status === 401) {
        tokenRefresh();
      } else {
        handleApiError(error);
      }
      setOrderLinesData([]);
      setTotalRows(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrderLines();
  }, [jobId, currentPage, rowsPerPage]);

  const hasCanceledLines = useMemo(() => {
    return Array.isArray(orderLinesData) && orderLinesData?.some((line) => line.line_state === "canceled");
  }, [orderLinesData]);

  const orderLinesColumns = useMemo(
    () => getOrderLinesColumns(hasCanceledLines),
    [hasCanceledLines]
  );

  const getRowBackgroundColor = (row) => {
    if (!row) return "#ffffff";
    
    if (row.line_state === "canceled") {
      return "#ffebee";
    }
    
    if (row?.order_line_color_satate) {
      if (row.order_line_color_satate === "white") {
        return "#ffffff";
      }
      return row.order_line_color_satate;
    }
    
    return "#ffffff";
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const safeOrderLinesData = Array.isArray(orderLinesData) ? orderLinesData : [];

  return (
    <Box sx={{ mt: 2 }}>
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 600,
          mb: 2,
          color: "#202124",
          fontSize: "16px",
        }}
      >
        Order Lines
      </Typography>

      {/* Color Legend */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          mb: 2,
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <InfoIcon sx={{ fontSize: "0.875rem", marginRight: "4px", color: "#667085" }} />
        <Typography
          variant="body2"
          sx={{
            fontSize: "0.75rem",
            textAlign: "left",
            marginRight: "8px",
            color: "green",
          }}
        >
          Green - Picked
        </Typography>
        <Divider orientation="vertical" flexItem sx={{ marginRight: "8px" }} />
        <Typography
          variant="body2"
          sx={{
            fontSize: "0.75rem",
            textAlign: "left",
            marginRight: "8px",
            color: "#FF0000",
          }}
        >
          Red - Canceled
        </Typography>
        <Divider orientation="vertical" flexItem sx={{ marginRight: "8px" }} />
        <Typography
          variant="body2"
          sx={{
            fontSize: "0.75rem",
            textAlign: "left",
            marginRight: "8px",
            color: "#be8800",
          }}
        >
          Yellow - Freight
        </Typography>
        <Divider orientation="vertical" flexItem sx={{ marginRight: "8px" }} />
        <Typography
          variant="body2"
          sx={{
            fontSize: "0.75rem",
            textAlign: "left",
            marginRight: "8px",
          }}
        >
          White - Not Picked
        </Typography>
        <Divider orientation="vertical" flexItem sx={{ marginRight: "8px" }} />
        <Typography
          variant="body2"
          sx={{
            fontSize: "0.75rem",
            textAlign: "left",
            marginRight: "8px",
            color: "#8d6e63",
          }}
        >
          Brown - Return
        </Typography>
        <Divider orientation="vertical" flexItem sx={{ marginRight: "8px" }} />
        <Typography
          variant="body2"
          sx={{
            fontSize: "0.75rem",
            textAlign: "left",
            color: "#1e3a8a",
          }}
        >
          Blue - Return Picked
        </Typography>
      </Box>

      <TableContainer sx={{ mb: 3, position: "relative" }}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#d6d6d6ff" }}>
              {orderLinesColumns.map((column) => (
                <TableCell 
                  key={column.id || column.field} 
                  align={column.align || "left"}
                  sx={{
                    fontWeight: 700,
                    color: "#242424ff",
                  }}
                >
                  {column.headerName || column.header || column.field}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={orderLinesColumns.length} align="center">
                  <CustomLoadingOverlay loadingText="Loading order lines..." />
                </TableCell>
              </TableRow>
            ) : safeOrderLinesData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={orderLinesColumns.length} align="center">
                  <Typography variant="body2" color="text.secondary">
                    No order lines found
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              safeOrderLinesData.map((row) => (
                <TableRow
                  key={row.line_id || row.id || Math.random()}
                  sx={{
                    backgroundColor: getRowBackgroundColor(row),
                    "&:hover": {
                      backgroundColor: getRowBackgroundColor(row),
                    },
                    cursor: "pointer",
                  }}
                >
                  {orderLinesColumns.map((column) => (
                    <TableCell
                      key={`${row.line_id || row.id}-${column.id || column.field}`}
                      align={column.align || "left"}
                      sx={{
                        fontSize: "13px",
                        fontWeight: 500,
                        color: "#374151",
                        borderColor: "#F0F0F0",
                      }}
                    >
                      {column.render
                        ? column.render(row)
                        : row[column.field]}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={totalRows}
        page={currentPage}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 20, 50]}
      />
    </Box>
  );
};

export default OrderLinesTable;